module.exports = __webpack_public_path__ + "img/es.70c13cd0.svg";